/**
 * @author Jafar Amini in March 2018.
 */
export enum RequestContentType {
  NONE = 0,
  JSON = 1,
  FORM = 2,
  FORM_DATA = 3,
  TEXT = 4,
  BLOB = 5,
  ARRAY_BUFFER = 6,
}
